import { BackendApiUrl } from "@/functions/BackendApiUrl";
import { ResponseDetails } from "@/functions/tryFetchJson";
import { useFetchWithAccessToken } from "@/functions/useFetchWithAccessToken";
import { CheckEmailResponse, ForgotPasswordFormData, LoginResponse, ResendConfirmEmailRequest, UpdateUserRequest } from "./interfaces/AuthenticationInterface";

export function useLoginService (){
    const { fetchPOST } = useFetchWithAccessToken();
    
    const loginHandler = async (encryptedEmail: string, encryptedPassword: string, rememberMe: boolean) => {
        const payload = {
            email : encryptedEmail,
            password : encryptedPassword,
            rememberMe : rememberMe
        }
        const response: ResponseDetails<LoginResponse> = await fetchPOST(BackendApiUrl.login, payload);
        return response;
    } 
    return { loginHandler };
}

export function useForgotPassword (){
    const { fetchPOST } = useFetchWithAccessToken();
    
    const forgotPassword = async (email: string) => {
        const payload : ForgotPasswordFormData = {
            email : email,
        }
        const response = await fetchPOST(BackendApiUrl.forgotPassword, payload);
        return response;
    } 
    return { forgotPassword };
}

export function useCheckEmail(){
    const { fetchPOST } = useFetchWithAccessToken();
    
    const checkEmail = async (encryptedEmail: string) => {
        const payload: ForgotPasswordFormData = {
            email : encryptedEmail,
        }
        const response: ResponseDetails<CheckEmailResponse> = await fetchPOST(BackendApiUrl.checkEmail, payload);
        return response;
    } 
    return { checkEmail };
}

export function useChangePassword(){
    const { fetchPOST } = useFetchWithAccessToken();
    
    const changePassword = async (request:{
        id: string;
        currentPassword: string;
        newPassword: string;
        confirmNewPassword: string;
    }) => {
        const payload: UpdateUserRequest = {
            id : request.id,
            currentPassword: request.currentPassword,
            newPassword: request.newPassword,
            confirmNewPassword: request.confirmNewPassword
        }
        const response = await fetchPOST(BackendApiUrl.changePassword, payload);
        return response;
    } 
    return { changePassword };
}

export function useResendConfirmEmail(){
    const { fetchPOST } = useFetchWithAccessToken();
    
    const resendConfirmEmail = async (encryptedEmail: string) => {
        const payload: ResendConfirmEmailRequest = {
            email: encryptedEmail,
        };
        const response = await fetchPOST(BackendApiUrl.resendConfirmEmail, payload);
        return response;
    } 
    return { resendConfirmEmail };
}
